module.exports = __webpack_public_path__ + "static/img/bg_bricks.649ddb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_bricks.png
// module id = ob44
// module chunks = 0